import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";


@Entity("code_list_log")
export class CodeListLog {

    @PrimaryGeneratedColumn("increment", { name: 'codelist_log_id' })
    codeListLogId: number;


    @Column({
        type: 'int',
        nullable: false,
        name: 'code_list_main_id'
    })
    codeListMainId: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'code_list_main_item_id'
    })
    codeListMainItemId: number;

    @Column('int', {
        nullable: false,
        name: "sale_order_id"
    })
    saleOrderId: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'sale_order_item_id'
    })
    soItemId: number;

    @Column({
        type: 'varchar',
        nullable: false,
        name: 'code'
    })
    code: string;

    @Column({
        type: 'int',
        nullable: false,
        name: 'tracebility_code_id'
    })
    tracebilityCodeId: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'cartons'
    })
    cartons: number;

    @Column({
        type: 'datetime',
        nullable: false,
        name: 'production_date'
    })
    productionDate: Date;

    @Column({
        type: 'datetime',
        nullable: false,
        name: 'best_before_date'
    })
    bestBeforeDate: Date;
    @Column("int", {
        nullable: false,
        name: "unit_id",
        default: 0
    })
    unitId: number;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


}